import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, Card } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import Modal from "react-awesome-modal";
import init from "Helpers/WindowToken";

export default class UpdateMediaFolder extends Component {
  state = {
    folder_id: null,
    folder_name: "",
    images: [],
    newImages: [],
    selectedImages: [],
    showDeleteModal: false, // ✅ modal state
    notification: false,
    message: "",
    page: 1,
    limit: 24,
    totalPages: 1,
    totalRecords: 0,
    loading: false,
  };

  componentDidMount() {
    this.fetchData();
  }

  getId = () => {
    return this.props?.params?.id || window.location.pathname.split("/").pop();
  };

  fetchData = async (page = this.state.page) => {
    try {
      const id = this.getId();

      if (init() === "success") {
        this.setState({ loading: true });
        const resp = await axios.post(Constants.getUrls.getFolderImages, {
          folder_id: id,
          page,
          limit: this.state.limit,
        });
        const responseData = resp.data.data || {};
        const pagination = responseData.pagination || {};

        this.setState({
          folder_id: responseData.folderData?.id,
          folder_name: responseData.folderData?.folder_name,
          images: responseData.images || [],
          page: pagination.page || page,
          totalPages: pagination.totalPages || 1,
          totalRecords: pagination.totalRecords || 0,
          loading: false,
        });
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
      console.log(err);
      this.setState({ loading: false });
    }
  };

  handleImageUpload = (e) => {
    this.setState({
      newImages: e.target.files,
    });
  };

  handleAddImages = async () => {
    const { newImages, folder_id, folder_name } = this.state;

    if (!newImages.length) {
      return this.setState({
        notification: true,
        message: "Please select images",
      });
    }

    try {
      const fd = new FormData();

      fd.append("folder_name", folder_name);
      fd.append("folder_id", folder_id);

      for (let i = 0; i < newImages.length; i++) {
        fd.append("images", newImages[i]);
      }

      if (init() === "success") {
        await axios.post(Constants.postUrls.addImagesToFolder, fd);

        this.setState({
          notification: true,
          message: "Images added successfully!",
          newImages: [],
        });

        this.fetchData(this.state.page);
      }
    } catch (err) {
      this.setState({
        notification: true,
        message: "Upload failed!",
      });
    }
  };

  // ✅ Select toggle
  handleSelectImage = (image_id) => {
    this.setState((prev) => {
      const exists = prev.selectedImages.includes(image_id);

      if (exists) {
        return {
          selectedImages: prev.selectedImages.filter((id) => id !== image_id),
        };
      } else {
        return {
          selectedImages: [...prev.selectedImages, image_id],
        };
      }
    });
  };

  // ✅ Open modal
  openDeleteModal = () => {
    if (!this.state.selectedImages.length) {
      return this.setState({
        notification: true,
        message: "Please select images",
      });
    }

    this.setState({ showDeleteModal: true });
  };

  // ✅ Close modal
  closeDeleteModal = () => {
    this.setState({ showDeleteModal: false });
  };

  // ✅ Confirm delete
  confirmDelete = async () => {
    const { folder_id, selectedImages } = this.state;

    try {
      if (init() === "success") {
        await axios.post(Constants.deleteUrls.deleteImageFromFolder, {
          folder_id,
          image_ids: selectedImages,
        });

        this.setState({
          notification: true,
          message: "Images deleted successfully!",
          selectedImages: [],
          showDeleteModal: false,
        });

        this.fetchData(this.state.page);
      }
    } catch (err) {
      console.log(err);

      this.setState({
        notification: true,
        message: "Delete failed!",
        showDeleteModal: false,
      });
    }
  };

  render() {
    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="dark"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                {this.state.folder_name} - Media Manager
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              {/* Add Images */}
              <Grid container spacing={2}>
                <Grid item>
                  <input
                    type="file"
                    multiple
                    onChange={this.handleImageUpload}
                  />
                </Grid>
                <Grid item>
                  <MDButton color="info" onClick={this.handleAddImages}>
                    Add More Images
                  </MDButton>
                </Grid>
              </Grid>

              <MDBox
                mt={2}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                flexWrap="wrap"
                gap={2}
              >
                <MDTypography variant="button" color="dark">
                  {this.state.loading
                    ? "Loading images..."
                    : `Page ${this.state.page} of ${this.state.totalPages} (${this.state.totalRecords} images)`}
                </MDTypography>
                <div style={{ display: "flex", gap: 10 }}>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    disabled={this.state.loading || this.state.page <= 1}
                    onClick={() => this.fetchData(this.state.page - 1)}
                  >
                    Prev
                  </MDButton>
                  <MDButton
                    variant="outlined"
                    color="dark"
                    disabled={
                      this.state.loading || this.state.page >= this.state.totalPages
                    }
                    onClick={() => this.fetchData(this.state.page + 1)}
                  >
                    Next
                  </MDButton>
                </div>
              </MDBox>

              {/* Images Grid */}
              <Grid container spacing={2} mt={2}>
                {this.state.images.map((img) => {
                  const isSelected = this.state.selectedImages.includes(img.id);

                  return (
                    <Grid item xs={6} sm={3} key={img.id}>
                      <div
                        onClick={() => this.handleSelectImage(img.id)}
                        style={{
                          border: isSelected
                            ? "3px solid red"
                            : "2px solid transparent",
                          cursor: "pointer",
                          position: "relative",
                        }}
                      >
                        <img
                          src={Constants.imageDomain + img.image_path}
                          alt="media"
                          style={{
                            width: "100%",
                            height: 150,
                            objectFit: "cover",
                          }}
                        />

                        {isSelected && (
                          <div
                            style={{
                              position: "absolute",
                              top: 5,
                              left: 5,
                              background: "red",
                              color: "#fff",
                              padding: "2px 6px",
                            }}
                          >
                            ✓
                          </div>
                        )}
                      </div>
                    </Grid>
                  );
                })}
              </Grid>

              {!this.state.loading && this.state.images.length === 0 && (
                <MDBox mt={2}>
                  <MDTypography variant="button" color="dark">
                    No images found in this folder.
                  </MDTypography>
                </MDBox>
              )}

              {/* Delete Button */}
              {this.state.selectedImages.length > 0 && (
                <Grid mt={3}>
                  <MDButton color="error" onClick={this.openDeleteModal}>
                    Delete Selected ({this.state.selectedImages.length})
                  </MDButton>
                </Grid>
              )}

              {/* ✅ Modal */}
              <Modal
                visible={this.state.showDeleteModal}
                width="400"
                height="200"
                effect="fadeInUp"
                onClickAway={this.closeDeleteModal}
              >
                <div style={{ padding: 20, textAlign: "center" }}>
                  <h3>Are you sure?</h3>
                  <p>Do you really want to delete selected images?</p>

                  <div style={{ marginTop: 20 }}>
                    <MDButton
                      color="error"
                      onClick={this.confirmDelete}
                      style={{ marginRight: 10 }}
                    >
                      Yes, Delete
                    </MDButton>

                    <MDButton color="secondary" onClick={this.closeDeleteModal}>
                      Cancel
                    </MDButton>
                  </div>
                </div>
              </Modal>
            </MDBox>

            <MDSnackbar
              color="success"
              title="Media Manager"
              content={this.state.message}
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
